<i18n>
{
	"en": {
			"noLoadingInformation": "There is no loading information yet."
	},
	"no": {
			"noLoadingInformation": "Det er ingen lasteopplysninger ennå."
	}
}
</i18n>
<template>
	<t-no-content-panel
		:text="$t('noLoadingInformation')"
		icon="truck-front"
	/>
</template>

<script>
export default { name: 'LoadingInformation', };
</script>

